<template>
    <div class="content">
        <v-flex align-self-center>
            <h2>{{ title }}</h2>
        </v-flex>
        <v-flex>
            <article>
                <img class="img" :src="imageUrl" alt="">
            </article>
        </v-flex>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: "",
            },
            imageUrl: {
                type: String,
                default: "",
            }
        },
        data(){
            return {}
        }
    }
</script>

<style  lang="scss" scoped>
    .content {
        border-left: 1px solid #e4e4e4;
        padding-left:20px;
        margin-bottom: 40px;
        margin-top: 60px;
    h2 {
        margin-top: 0;
        font-size: 36px;
        font-weight: 400;
        text-align: center;

    }
    h3 {
        text-align: center;
    }
    .img{
        width:100%;
    }
    }
    article p {
        text-indent: 2em;
        font-size: 16px;
        color: #666;
    }

</style>
